// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Lx5rA","selected":"styles_selected__RdgAf","disabled":"styles_disabled__FtQW8"};